export default {
  filterActive({ filter }) {
    return filter.level.length > 0;
  },
};



// WEBPACK FOOTER //
// ./assets/js/timetable/store/getters.js